export const capitalizeFirstLetter = (string) => string.charAt(0).toUpperCase() + string.slice(1);

export const noSpecialCharacters = (string) => (
  string.toLowerCase()
      .replace(/[\s_\-.,;:"'?!€%*]+/g, '-')
      .replace(/(^-|-$)/g, '')
      .replace(/[áâàä]/g, 'a')
      .replace(/[éêèë]/g, 'e')
      .replace(/[íîìï]/g, 'i')
      .replace(/[óôòö]/g, 'o')
      .replace(/[úûùü]/g, 'u')
      .replace(/[ýÿ]/g, 'y')
      .replace(/ñ/g, 'n')
      .replace(/œ/g, 'oe')
      .replace(/æ/g, 'ae')
      .replace(/ç/g, 'c')
);

export const snakeCase = (string) => (
  noSpecialCharacters(string).replace(/-/g, '_')
);